import { fromEntries, fx, keys } from '@fxts/core';
import { KeyMapType } from '../../../../../../shared/type/util.type.ts';
import { AllProductTypes } from '@services/MarppleShopStudio/widget/CreatorProduct/core/zod-schema/types.ts';
import { Paths } from '../../../../../../shared/type/ObjectPaths.ts';
import {
  PRODUCT_PRICE__MAX,
  PRODUCT_PRICE__MIN,
} from '@services/MarppleShopStudio/widget/CreatorProduct/core/zod-schema/constants.ts';
import { commify } from '@services/MarppleShop/shared/util/commify.ts';

export const keyNameFormPathMap = {
  is_force_out_of_stock: 'is_force_out_of_stock',
  sp_cate_root_code: 'sp_cate_root_code',
  sp_cate_list_code: 'sp_cate_list_code',
  sp_cate_item_code: 'sp_cate_item_code',
  membership_ids: 'membership_ids',
  product_name: '_.product.name',
  product_name_en: '_.product.name_en',
  product_name_jp: '_.product.name_jp',
  is_public: '_.product.is_public',
  profit: '_.product.profit',
  max_purchase_per_user: 'max_purchase_per_user',
  sell_start_at: 'sell_start_at',
  sell_end_at: 'sell_end_at',
  spo_items: '_.product._.spo._.spo_items',
  spo_text_options: '_.product._.spo._.spo_text_options',
  spo_options: '_.product._.spo._.spo_options',
  stock_type: '_.product._.spo.stock_type',
  meta: 'meta',
  limited: 'meta.limited',
  low_stock_threshold: 'meta.low_stock_threshold',
  max_days: '_.product._.spo._.spo_producing_period.max_days',
  product_basic_info: 'product_basic_info',
} as const satisfies Record<string, Paths<AllProductTypes>>;

export type ValidateField = keyof typeof keyNameFormPathMap;

export const formKeyMap = fromEntries(
  fx(keys(keyNameFormPathMap))
    .map((k) => [k, k] as const)
    .toArray(),
) as KeyMapType<KeyMapType<typeof keyNameFormPathMap>>;

export const errorMessage = {
  get required() {
    return '필수 입력 사항입니다.';
  },
  get min_text() {
    return '3자 이상 입력해 주세요.';
  },
  get text_length_100() {
    return '100자 이하로 입력해 주세요.';
  },
  get restrict_character2() {
    return '특수문자는 * - · ( ) [ ] / & + , ~ . : @ ! 만 입력 가능합니다.';
  },
  get black_list_name() {
    return '사용 불가능한 단어가 포함되어 있습니다.';
  },
  get select_category() {
    return '상품 카테고리를 설정해 주세요.';
  },
  get only_number() {
    return '숫자를 입력해 주세요.';
  },
  get min_price() {
    return `최소 ${commify(PRODUCT_PRICE__MIN)}원 이상 입력해 주세요.`;
  },
  get max_price() {
    return `최대 ${commify(PRODUCT_PRICE__MAX)}원 이하로 입력해 주세요.`;
  },
};
